export class PageReorder {
	previousIndex: number;
	nextIndex: number;
}